<template>
  <div class="patients">
    <ul>
      <li v-for="questionnaire in questionnaires" :key="questionnaire.questionnaire.name">
        <router-link
          :to="questionnaireUrl(questionnaire)">
          <p>{{questionnaire.questionnaire.name}}</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {getPatientQuestionnaires} from '@/api/questionnaire'

export default {
  data() {
    return {questionnaires: []}
  },

  mounted() {
    this.getQuestionnaires()
  },

  props: {id: String},

  computed: {
    questionnaireUrl() {
      const vm = this

      return function(questionnaire) {
        return `/patients/${vm.id}/questionnaire/${questionnaire.id}`
      }
    }
  },

  methods: {
    getQuestionnaires() {
      getPatientQuestionnaires(this.id).then(({data}) => {
        this.questionnaires = data
      })
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .patients
    .table
      /* TODO: no... */
      box-shadow: $color-shadow

      tr
        cursor: pointer

      .table-header, .table-row
        border-bottom: 1px solid $color-grey-light
</style>



// WEBPACK FOOTER //
// src/components/pages/Patients/PatientQuestionnaires.vue